import React from "react";

import Hero from "./sections/Hero";
import Tabs from "./sections/Tabs";

const ServiceRegister = () => {
  return (
    <>
      <Hero />
      <Tabs />
    </>
  )
}

export default ServiceRegister;